import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/zip.js
// module id = 1587
// module chunks = 3